exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__layout___XYLAg .index-module__content___1yP3K{height:calc(var(--app-height) - 70px)}", ""]);

// exports
exports.locals = {
	"layout": "index-module__layout___XYLAg",
	"content": "index-module__content___1yP3K"
};